module.exports = __webpack_public_path__ + "img/ph.80e522fc.png";